module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "om-container"
  }, [_c('div', {
    staticClass: "om-login"
  }, [_c('div', {
    staticClass: "om-center om-main-logo"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/logo.png",
      "alt": _vm.$tr('OmniWay', 'Login')
    }
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.isFormReady) ? _c('form', {
    staticClass: "om-form--login",
    attrs: {
      "autocomplete": "off"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.loginAction.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "om-center"
  }, [(_vm.settings && _vm.settings.logo_url) ? _c('img', {
    staticClass: "om-user-logo",
    attrs: {
      "src": _vm.settings.logo_url,
      "alt": _vm.$tr('Logo', 'Login')
    }
  }) : _c('img', {
    staticClass: "om-user-logo",
    attrs: {
      "src": "/static/temp/logo-patrizia-aryton.png",
      "alt": _vm.$tr('Logo', 'Login')
    }
  })]), _vm._v(" "), (_vm.settings) ? _c('h3', {
    staticClass: "om-form--login__heading"
  }, [_vm._v("\n          " + _vm._s(_vm.tr('Zaloguj się do systemu', 'Login')) + "\n          " + _vm._s(_vm.settings.name) + "\n        ")]) : _c('h3', {
    staticClass: "om-form--login__heading"
  }, [_vm._v("\n          " + _vm._s(_vm.tr('Zaloguj się do systemu Aryton Omniway', 'Login')) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "om-form--login__group"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (_vm.validateRules.username),
      expression: "validateRules.username"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    staticClass: "om-form--login__input--login",
    class: {
      'is-invalid': _vm.errors.has('username'),
      'is-not-empty': _vm.username.length
    },
    attrs: {
      "id": "username",
      "name": "username"
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "om-form--login__label",
    attrs: {
      "for": "username"
    }
  }, [_vm._v(_vm._s(_vm.$tr('Login', 'Login')))]), _vm._v(" "), _c('img', {
    staticClass: "input-icon",
    attrs: {
      "src": "/static/img/icon-person.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "om-form--login__group"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (_vm.validateRules.password),
      expression: "validateRules.password"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "om-form--login__input--login",
    class: {
      'is-invalid': _vm.errors.has('password'),
      'is-not-empty': _vm.password.length
    },
    attrs: {
      "id": "password",
      "name": "password",
      "type": "password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "om-form--login__label",
    attrs: {
      "for": "password"
    }
  }, [_vm._v(_vm._s(_vm.tr('Hasło', 'Login')))]), _vm._v(" "), _c('img', {
    staticClass: "input-icon",
    attrs: {
      "src": "/static/img/icon-lock.png",
      "alt": ""
    }
  })]), _vm._v(" "), (_vm.visibleSubdomain) ? _c('div', {
    staticClass: "om-form--login__group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.subdomain),
      expression: "subdomain"
    }],
    staticClass: "om-form--login__input--login",
    class: {
      'is-not-empty': _vm.subdomain.length
    },
    attrs: {
      "id": "subdomain",
      "name": "subdomain"
    },
    domProps: {
      "value": (_vm.subdomain)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.subdomain = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "om-form--login__label",
    attrs: {
      "for": "subdomain"
    }
  }, [_vm._v(_vm._s(_vm.$tr('Subdomena (tymczasowo)', 'Login')))]), _vm._v(" "), _c('img', {
    staticClass: "input-icon",
    attrs: {
      "src": "/static/img/icon-person.png",
      "alt": ""
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "om-form--login__group"
  }, [_c('button', {
    staticClass: "om-form--login--login__submit",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.loginAction.apply(null, arguments)
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.tr('Zaloguj się', 'Login')) + "\n          ")])])]) : _vm._e()])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4fed48a2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login.vue
// module id = 280
// module chunks = 1